import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(
    private http: HttpClient
  ) { }
  public companyId = "";
  public action = "";
  private options = { headers: new HttpHeaders().set('isUpload', 'true') };

  GetCompany() {
    return this.http.get(environment.apiURL + `company/GetCompany`);
  }
  GetCompanyByCreatedDate(date){
    return this.http.get(environment.apiURL + `company/GetCompany?Isactive=true&CreatedOn=`+date);
  }
  GetCompanyByDateWise(fromdate,todate){
    return this.http.get(environment.apiURL + `company/GetCompany?Isactive=true&FromDate=`+fromdate+`&ToDate=`+todate);
  }
  GetCompetitor() {
    return this.http.get(environment.apiURL + `company/GetCompany?Isactive=true`);
  }
  GetIndustry() {
    return this.http.get(environment.apiURL + `master/GetIndustry`);
  }
  GetThemes() {
    return this.http.get(environment.apiURL + `master/GetThemes`);
  }

  AddCompany(data) {
    return this.http.post(environment.apiURL + `company/AddCompany`, data);
  }

  UploadCompanyLogo(formData) {
    return this.http.post(environment.apiURL + `company/UploadCompanyLogo`, formData, this.options);
  }

  UploadInvestors(formData) {
    return this.http.post(environment.apiURL + `company/UploadCompanyInvestors`, formData, this.options);
  }

  GetCompanyDetails(CompanyID) {
    return this.http.get(environment.apiURL + `company/GetCompany?_id=` + CompanyID);
  }

  UpdateCompany(data) {
    return this.http.post(environment.apiURL + `company/UpdateCompany`, data);
  }
  DeleteCompany(data) {
    return this.http.post(environment.apiURL + `company/DeleteCompany`, data);
  }

  DeleteCompanyInvestorFile(data) {
    return this.http.post(environment.apiURL + `company/DeleteCompanyInvestorsAttachment`, data);
  }

  DeleteCompanyInvestor(data) {
    return this.http.post(environment.apiURL + `company/DeleteCompanyInvestors`, data);
  }

  globalSearch(data) {
    return this.http.post(environment.apiURL + `company/globalSearch`, data);
  }
}
